import { useParams } from 'react-router-dom';

import PortfolioScreen from '../../features/projects/layouts/portfolio';
import ProjectWorkspace from '../../features/projects/layouts/workspace';
import CreateProjectForm from '../../features/projects/forms/create';
import EditProjectForm from '../../features/projects/forms/edit';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/projects            → la sección, con sus dos pestañas en ?tab=
//   /admin/projects/new        → the create form (static route, no param)
//   /admin/projects/:id        → the workspace, summary tab
//   /admin/projects/:id/:tab   → the workspace, that tab
//   /admin/projects/:id/edit   → configuration, behind projects:write
//
// The tab lives in the path and not in component state so a section can be
// linked to and come back on the Back button. `edit` is a static segment, so
// the router ranks it above `:tab` and there is no collision.

export default function ProjectsPage({ mode }) {
    const { id, tab } = useParams();

    if (mode === 'create' || id === 'new') return <CreateProjectForm />;
    if (mode === 'edit' && id) return <EditProjectForm projectId={id} />;
    if (id) return <ProjectWorkspace projectId={id} tab={tab ?? 'resumen'} />;
    return <PortfolioScreen />;
}
